module.exports = __webpack_public_path__ + "static/media/trash-can.129b5dba.svg";